import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//
import * as Sentry from "@sentry/react";
// translations
// TODO: i think we probably want to lazy load these eventually. This adds ~35KB to bundle size
// for no good reason
import translationConfigEn from "./locales/en.json";
import translationEs from "./locales/es.json";
import translationAr from "./locales/ar.json";
import translationRu from "./locales/ru.json";
import translationUk from "./locales/uk.json";
import translationVi from "./locales/vi.json";
import translationZhCN from "./locales/zh-CN.json";
import translationFrCA from "./locales/fr-CA.json";
import so from "./locales/so.json";
import hmn from "./locales/hmn.json";

// types
import type { TranslationConfig } from "./locales/types";

export const DEFAULT_LANGUAGE = "en";

export type SupportedLanguage = "en" | "es" | "ar" | "ru" | "uk" | "vi" | "zh-CN" | "fr-CA" | "so" | "hmn";
// NOTE: if any JSON file doesn't adhear to type of english translation config interface, there's a TS error
type I18nResources = Record<SupportedLanguage, { translation: TranslationConfig }>;

export const resources: I18nResources = {
  en: { translation: translationConfigEn },
  es: { translation: translationEs },
  ar: { translation: translationAr },
  ru: { translation: translationRu },
  uk: { translation: translationUk },
  vi: { translation: translationVi },
  "zh-CN": { translation: translationZhCN },
  "fr-CA": { translation: translationFrCA },
  so: { translation: so },
  hmn: { translation: hmn },
} as const;

export const SUPPORTED_LANGUAGES = Object.keys(resources) as SupportedLanguage[];

i18n
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    // alert us if the key is missing! `saveMissing` is misleading. We don't save anything to the translations files/backend/etc.
    // like what missingKeyHandler is intended for. But `saveMissing` must be set to `true` for this handler func to get called
    saveMissing: true,
    missingKeyHandler: (lngs, namespace, key, res) => {
      Sentry.captureMessage("Missing translation key", { extra: { key } });
    },
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    supportedLngs: SUPPORTED_LANGUAGES,
  });
